import { PropTypes } from "prop-types";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

const Meta = ({ title }) => {
    const { t } = useTranslation();

    const location = useLocation();

    return (
        <Helmet>
            <title>
                {title} | {t("labels.cmsTitle")}
            </title>
            <meta content={t("labels.metaDescription")} name="description" />
            <meta content={t("labels.metaKeywords")} name="keywords" />
            <meta content={`${title} | ${t("labels.cmsTitle")}`} property="og:title" />
            <meta content={t("labels.metaDescription")} property="og:description" />
            <meta content={`${import.meta.env.VITE_HOST}/logo.png`} property="og:image" />
            <meta content={`${import.meta.env.VITE_HOST}${location.pathname}${location.search}`} property="og:url" />
        </Helmet>
    );
};

export default Meta;

Meta.propTypes = { title: PropTypes.string };
